import gButton from "@/components/g-button/g-button";
import gCard from "@/components/g-card/g-card.vue";
import gDateInput from "@/components/g-date-input/g-date-input";
import gForm from "@/components/g-form/g-form";
import ClienteController from "@/shared/controllers/cliente/clienteController";
import EmpresaController from "@/shared/controllers/empresa/empresaController";
import DocumentoController from "@/shared/controllers/documento/documentoController";
import FiltroTitulos from "@/shared/view-models/Filtros/FiltroTitulos";
import {valorMonetario} from '../../../shared/services/tools.js'
import { defineComponent } from "vue";
import AccountLoged from "@/shared/mixins/AccountLoged";




const name = 'Titulos'
export default defineComponent({
  name,

  components: {
    'g-button': gButton,
    'g-card': gCard,
    'g-date-input': gDateInput,
    'g-form': gForm
  },

  props: { },
  mixins:[AccountLoged],

  mounted () {
    if(!this.hasClaim('Consultas-Títulos')) {
      this.$router.push('/sem-acesso')
    }
    this.mitt.on('trocaEmpresaRepresentante', () => {
      this.atualizaEmpresaRepresentante()
    })
    this.UnidadeArray = EmpresaController.getEmpresasAtivas().EmpresaArray;
    this.popularDropDownEmpresa();
    this.getInfoDocumentos()


    this.TitulosPorNotasFiscais()

  },
  watch: {
    objFiltro() {
      if (this.objFiltro.ClienteId == (undefined || null))
      {
        this.ClienteAgrupadorAtiva = true;
      }
     }
  },
  updated () { },

  data () {
    return {
      totalDeTodosOsRepresentates:0,
      arrayRepresentantes:[],
      DataInicioVencimento: '',
      codigoExternoNF : this.$route.params.codigoExternoNF,
      DataTerminoVencimento: '',
      DataInicioBaixa: '',
      DataTerminoBaixa: '',
      CheckboxConsultas: false,
      CheckboxDoc: false,
      DataInicioEmissao: '',
      DataTerminoEmissao: '',
      objFiltro: new FiltroTitulos(),
      mensagemvazio: true,
      EmpresaId: '',
      ClienteId: '',
      NotaFiscalId: '',
      ClientesArray: [],
      EmpresaArray: [],
      UnidadeArray: [],
      SituacaoDocumento: 0,
      Tipo: 0,
      SituacaoArray: [{ "text": "Abertos", "value": 0, "enum": 0 },
      { "text": "À vencer", "value": 1, "enum": 1 }, 
      { "text": "Vencidos", "value": 2, "enum": 2 }, 
      { "text": "Pagos", "value": 3, "enum": 3 }],
      TipoArray: [],
      pedidoId: null,
      TipoEmissaoArray: [],
      TituloArray: [],
      ClienteAgrupadorAtiva: true,
      tituloSelecionado: '',
      /*DocumentoId
        CodigoExterno
        ValorBruto
        ValorSaldo
        DataVencimento
        DiasAtraso
        TipoDocumento
        DataVencimentoFormatada*/
      Colunas : [
        {field: 'numeroTitulo', header: 'Título'},
        {field: 'valorBrutoFormatado', header: 'Valor (R$)'},
        {field: 'valorSaldoFormatado', header: 'Saldo (R$)'},
        {field: 'dataEmissaoFormatada', header: 'Emissão'},
        {field: 'dataVencimentoFormatada', header: 'Vencimento'},
        {field: 'diasAtraso', header: 'Dias'},
        {field: 'tipoDocumento', header: 'Tipo'},
      ],
      Colunas2 : [],
      Filtro: {
        'global': {value: null, matchMode: this.filtros.CONTAINS},
        'numeroTitulo': {value: null, matchMode:this.filtros.CONTAINS},
        'valorBrutoFormatado': {value: null, matchMode: this.filtros.CONTAINS},
        'valorSaldoFormatado': {value: null, matchMode: this.filtros.CONTAINS},
        'dataEmissaoFormatada': {value: null, matchMode: this.filtros.CONTAINS},
        'dataVencimentoComDescontoFormatada': {value: null, matchMode: this.filtros.CONTAINS},
        'diasAtraso': {value: null, matchMode: this.filtros.CONTAINS},
        'tipoDocumentoEnumTexto': {value: null, matchMode: this.filtros.CONTAINS},
      },
    }
  },

  methods: {
    ativaClienteAgrupador() {
      this.ClienteAgrupadorAtiva = false;
    },
    GetPedidoByDocumentoId(data) {

      DocumentoController.GetPedidoByDocumentoId(data.documentoId).requisicao
      .then((res => {
        this.pedidoId = res.data.data.pedidoId;
        setTimeout(() => {
          this.pedidosRota()
        },1000)
      }))
    },
    buscarByFiltro() {
      this.$isLoading(true)
      this.objFiltro.RepresentanteId = this.$store.state.representanteSelecionadoId;
      this.objFiltro.NumeroTitulo =  this.objFiltro.NumeroTitulo ? this.objFiltro.NumeroTitulo.toString() : '';
      DocumentoController.GetTituloByFiltro(this.objFiltro).requisicao
        .then((response) =>{
          this.arrayRepresentantes = response.data.data.representantes
          this.totalDeTodosOsRepresentates = response.data.data.totalDeTodosOsRepresentates
          this.mensagemvazio = false
        })
        .finally(() => this.$isLoading(false))
    },
    
    getInfoDocumentos(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Documento/GetTipoDocumento`,
        })
              .then((response) => {
                let tiposIncluidos = [0,2]
                this.TipoArray = response.data.filter(x => tiposIncluidos.includes(x.value)) 
              })
              .catch(() => {
              });
              

        // this.axios({
        //   method: 'get',
        //   url: process.env.VUE_APP_WEB_API + `Documento/GetTipoEmissaoDocumento`,

        // })
        //       .then((response) => {
        //         this.TipoEmissaoArray = response.data
        //       })
        //       .catch(() => {
        //       });

        // this.axios({
        //   method: 'get',
        //   url: process.env.VUE_APP_WEB_API + `Documento/GetSituacaoDocumento`,

        // })
        //   .then(() => {
        //     // this.SituacaoArray = response.data

        //   })
        //   .catch(() => {
        //   });
    },
    atualizaEmpresaRepresentante(){
      //this.objFiltro.EmpresaId = this.$store.state.empresaSelecionadaId;
    },
    getEmpresas() {
      EmpresaController.getAllEmpresa()
        .requisicao.then((Response) => {
          this.atualizaEmpresaRepresentante();
          this.EmpresaArray = Response.data.data;
        })
        .catch((Error) => {
          console.error(Error);
        });
    },

    redirecionaTelaDetalhes(data) {
      const rotaNovaAbaURL = this.$router.resolve({
        path:`/detalhes-titulo/${data.documentoId}`
      }).href;
      
      window.open(rotaNovaAbaURL, '_blank');
    },

    limpar() {
      /*eslint-disable*/
      // 
      // this.objFiltro.DataBaixaInicio = undefined
      // this.objFiltro.DataBaixaTermino = undefined
       this.objFiltro = new FiltroTitulos();
      this.ClienteArray = []
      // EmpresaController.getEmpresasAtivas().requisicao
      // .then(response => {
      //     this.UnidadeArray = response.data.data
      //     this.atualizaEmpresaRepresentante()
      // })
      // this.mitt.on('trocaEmpresaRepresentante', () => {
      //     this.atualizaEmpresaRepresentante()
      // })
    },
    popularDropDownEmpresa(){
      this.EmpresaArray = this.$store.state.EmpresaArray;
      this.atualizaEmpresaRepresentante()
      },
    buscarClientes(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.ClientesArray = ClienteController.GetAllClientesByEmpresaIdEFiltro(this.objFiltro.EmpresaId, event).ClientesArray;
      }, 1000);
    },
    TitulosPorNotasFiscais(){
      this.codigoExternoNF = this.$route.params.codigoExternoNF
      if(this.codigoExternoNF != null && this.codigoExternoNF != ""){
          this.objFiltro.NumeroNotaFiscal = this.codigoExternoNF;
          this.buscarByFiltro();
      }
    },
    pedidosRota(){
      this.$router.push(`pedido-em-andamento-fluxo/${this.pedidoId}/detalhes-pedido-andamento`)
    },

    retornaTotalDoValorDoRepresentanteFormatado(valor){
      return valorMonetario(valor)  
    }

  },

  

});